export function formatSalesTitle(currentField, globalSalesTitle) {
    if (globalSalesTitle === 'Sales') {
        currentField = currentField?.replace('Sales', 'Conversions');
    }
    return currentField;
}
